import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const TrackingContext = React.createContext()

export function TrackingProvider({ children, location }) {
  useEffect(() => {
    customPageviewEvent(location.pathname)
  }, [location.pathname])

  function customPageviewEvent(path) {
    if (!window._mtm) return
    window._mtm.push({
      event: 'custom.pageview',
      path: path,
    })
  }

  function PushMessage(evt, message) {
    if (!window._mtm) return
    window._mtm.push({
      event: evt || 'custom.message',
      ...message,
    })
  }

  return (
    <TrackingContext.Provider value={{ customPageviewEvent, PushMessage }}>
      {children}
    </TrackingContext.Provider>
  )
}

TrackingProvider.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object.isRequired,
}

export default TrackingContext
